module.exports = __webpack_public_path__ + "catalog/items/measuring-arrow/measuring-arrow.svg";